module.exports = __webpack_public_path__ + "img/img-err.1b989215.png";